// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file security/security.proto (package lvdr.v2.security, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file security/security.proto.
 */
export const file_security_security: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * Sent on WS connect — current security state snapshot
 *
 * @generated from message lvdr.v2.security.SecuritySummary
 */
export type SecuritySummary = Message<"lvdr.v2.security.SecuritySummary"> & {
  /**
   * @generated from field: uint32 scanned_24h = 1;
   */
  scanned24h: number;

  /**
   * @generated from field: uint32 flagged_24h = 2;
   */
  flagged24h: number;

  /**
   * @generated from field: uint32 blocked_24h = 3;
   */
  blocked24h: number;

  /**
   * @generated from field: uint32 active_alerts = 4;
   */
  activeAlerts: number;

  /**
   * "none" | "low" | "medium" | "high" | "critical"
   *
   * @generated from field: string highest_severity = 5;
   */
  highestSeverity: string;
};

/**
 * Describes the message lvdr.v2.security.SecuritySummary.
 * Use `create(SecuritySummarySchema)` to create a new message.
 */
export const SecuritySummarySchema: GenMessage<SecuritySummary> = /*@__PURE__*/
  messageDesc(file_security_security, 0);

/**
 * Pushed on new flag/block event
 *
 * @generated from message lvdr.v2.security.SecurityAlert
 */
export type SecurityAlert = Message<"lvdr.v2.security.SecurityAlert"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * "flagged" | "blocked"
   *
   * @generated from field: string alert_type = 2;
   */
  alertType: string;

  /**
   * @generated from field: string severity = 3;
   */
  severity: string;

  /**
   * @generated from field: string source = 4;
   */
  source: string;

  /**
   * @generated from field: string summary = 5;
   */
  summary: string;

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 6;
   */
  timestamp?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.security.SecurityAlert.
 * Use `create(SecurityAlertSchema)` to create a new message.
 */
export const SecurityAlertSchema: GenMessage<SecurityAlert> = /*@__PURE__*/
  messageDesc(file_security_security, 1);

/**
 * Request current security summary (client → server)
 *
 * @generated from message lvdr.v2.security.SecuritySummaryRequest
 */
export type SecuritySummaryRequest = Message<"lvdr.v2.security.SecuritySummaryRequest"> & {
};

/**
 * Describes the message lvdr.v2.security.SecuritySummaryRequest.
 * Use `create(SecuritySummaryRequestSchema)` to create a new message.
 */
export const SecuritySummaryRequestSchema: GenMessage<SecuritySummaryRequest> = /*@__PURE__*/
  messageDesc(file_security_security, 2);

/**
 * Pushed when a user requests access to redacted content
 *
 * @generated from message lvdr.v2.security.AccessRequestEvent
 */
export type AccessRequestEvent = Message<"lvdr.v2.security.AccessRequestEvent"> & {
  /**
   * @generated from field: string grant_id = 1;
   */
  grantId: string;

  /**
   * @generated from field: string requester_id = 2;
   */
  requesterId: string;

  /**
   * @generated from field: string research_id = 3;
   */
  researchId: string;

  /**
   * @generated from field: string sensitivity_type = 4;
   */
  sensitivityType: string;

  /**
   * @generated from field: string reason = 5;
   */
  reason: string;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 6;
   */
  requestedAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.security.AccessRequestEvent.
 * Use `create(AccessRequestEventSchema)` to create a new message.
 */
export const AccessRequestEventSchema: GenMessage<AccessRequestEvent> = /*@__PURE__*/
  messageDesc(file_security_security, 3);

/**
 * Pushed when an access request is approved or denied
 *
 * @generated from message lvdr.v2.security.AccessDecisionEvent
 */
export type AccessDecisionEvent = Message<"lvdr.v2.security.AccessDecisionEvent"> & {
  /**
   * @generated from field: string grant_id = 1;
   */
  grantId: string;

  /**
   * "approved" or "denied"
   *
   * @generated from field: string decision = 2;
   */
  decision: string;

  /**
   * 0 = permanent
   *
   * @generated from field: int32 ttl_hours = 3;
   */
  ttlHours: number;

  /**
   * @generated from field: string note = 4;
   */
  note: string;

  /**
   * @generated from field: google.protobuf.Timestamp decided_at = 5;
   */
  decidedAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.security.AccessDecisionEvent.
 * Use `create(AccessDecisionEventSchema)` to create a new message.
 */
export const AccessDecisionEventSchema: GenMessage<AccessDecisionEvent> = /*@__PURE__*/
  messageDesc(file_security_security, 4);

/**
 * Reveal redacted content. Requires PermRedactionsReveal OR an active grant
 * for the specific sensitivity type(s). The research's owning org is
 * resolved server-side from research_id — callers do not pass an org ID.
 *
 * @generated from message lvdr.v2.security.RevealNodeRequest
 */
export type RevealNodeRequest = Message<"lvdr.v2.security.RevealNodeRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: string node_id = 2;
   */
  nodeId: string;
};

/**
 * Describes the message lvdr.v2.security.RevealNodeRequest.
 * Use `create(RevealNodeRequestSchema)` to create a new message.
 */
export const RevealNodeRequestSchema: GenMessage<RevealNodeRequest> = /*@__PURE__*/
  messageDesc(file_security_security, 5);

/**
 * @generated from message lvdr.v2.security.RevealNodeResponse
 */
export type RevealNodeResponse = Message<"lvdr.v2.security.RevealNodeResponse"> & {
  /**
   * @generated from field: string node_id = 1;
   */
  nodeId: string;

  /**
   * plaintext or partially-redacted, depending on access
   *
   * @generated from field: string content = 2;
   */
  content: string;

  /**
   * true = grant-based partial reveal; false = full
   *
   * @generated from field: bool partial = 3;
   */
  partial: boolean;

  /**
   * sensitivity types that were revealed
   *
   * @generated from field: repeated string revealed_types = 4;
   */
  revealedTypes: string[];
};

/**
 * Describes the message lvdr.v2.security.RevealNodeResponse.
 * Use `create(RevealNodeResponseSchema)` to create a new message.
 */
export const RevealNodeResponseSchema: GenMessage<RevealNodeResponse> = /*@__PURE__*/
  messageDesc(file_security_security, 6);

/**
 * List the caller's own access requests for a research.
 *
 * @generated from message lvdr.v2.security.ListMyAccessRequestsRequest
 */
export type ListMyAccessRequestsRequest = Message<"lvdr.v2.security.ListMyAccessRequestsRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;
};

/**
 * Describes the message lvdr.v2.security.ListMyAccessRequestsRequest.
 * Use `create(ListMyAccessRequestsRequestSchema)` to create a new message.
 */
export const ListMyAccessRequestsRequestSchema: GenMessage<ListMyAccessRequestsRequest> = /*@__PURE__*/
  messageDesc(file_security_security, 7);

/**
 * List all access requests for a research (admin only — gated on
 * PermAccessRequestApprove in the research's owning org).
 *
 * @generated from message lvdr.v2.security.ListAccessRequestsRequest
 */
export type ListAccessRequestsRequest = Message<"lvdr.v2.security.ListAccessRequestsRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * "" | "pending" | "approved" | "denied" | "expired" | "revoked"
   *
   * @generated from field: string status = 2;
   */
  status: string;
};

/**
 * Describes the message lvdr.v2.security.ListAccessRequestsRequest.
 * Use `create(ListAccessRequestsRequestSchema)` to create a new message.
 */
export const ListAccessRequestsRequestSchema: GenMessage<ListAccessRequestsRequest> = /*@__PURE__*/
  messageDesc(file_security_security, 8);

/**
 * Serialized form of an AccessGrant.
 *
 * @generated from message lvdr.v2.security.AccessGrant
 */
export type AccessGrant = Message<"lvdr.v2.security.AccessGrant"> & {
  /**
   * @generated from field: string grant_id = 1;
   */
  grantId: string;

  /**
   * @generated from field: string requester_id = 2;
   */
  requesterId: string;

  /**
   * @generated from field: string approver_id = 3;
   */
  approverId: string;

  /**
   * @generated from field: string research_id = 4;
   */
  researchId: string;

  /**
   * @generated from field: string sensitivity_type = 5;
   */
  sensitivityType: string;

  /**
   * @generated from field: string reason = 6;
   */
  reason: string;

  /**
   * @generated from field: string approver_note = 7;
   */
  approverNote: string;

  /**
   * @generated from field: string revoked_reason = 8;
   */
  revokedReason: string;

  /**
   * "pending" | "approved" | "denied" | "expired" | "revoked"
   *
   * @generated from field: string status = 9;
   */
  status: string;

  /**
   * @generated from field: google.protobuf.Timestamp requested_at = 10;
   */
  requestedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp decided_at = 11;
   */
  decidedAt?: Timestamp | undefined;

  /**
   * unset = permanent
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 12;
   */
  expiresAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.security.AccessGrant.
 * Use `create(AccessGrantSchema)` to create a new message.
 */
export const AccessGrantSchema: GenMessage<AccessGrant> = /*@__PURE__*/
  messageDesc(file_security_security, 9);

/**
 * @generated from message lvdr.v2.security.AccessGrantListResponse
 */
export type AccessGrantListResponse = Message<"lvdr.v2.security.AccessGrantListResponse"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: repeated lvdr.v2.security.AccessGrant grants = 2;
   */
  grants: AccessGrant[];
};

/**
 * Describes the message lvdr.v2.security.AccessGrantListResponse.
 * Use `create(AccessGrantListResponseSchema)` to create a new message.
 */
export const AccessGrantListResponseSchema: GenMessage<AccessGrantListResponse> = /*@__PURE__*/
  messageDesc(file_security_security, 10);

/**
 * Free-form source feedback (dismiss / false positive) on a broadcast alert.
 * Mirrors HTTP POST /security/source/feedback. Body today is advisory only —
 * the server logs it; no persistence. `feedback_type` is free-form ("dismissed"
 * | "false_positive" | …) to match the open HTTP contract; any server-side
 * enum tightening should happen behind a shared helper rather than here.
 *
 * @generated from message lvdr.v2.security.SubmitSourceFeedbackRequest
 */
export type SubmitSourceFeedbackRequest = Message<"lvdr.v2.security.SubmitSourceFeedbackRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * @generated from field: string feedback_type = 2;
   */
  feedbackType: string;

  /**
   * @generated from field: string comment = 3;
   */
  comment: string;
};

/**
 * Describes the message lvdr.v2.security.SubmitSourceFeedbackRequest.
 * Use `create(SubmitSourceFeedbackRequestSchema)` to create a new message.
 */
export const SubmitSourceFeedbackRequestSchema: GenMessage<SubmitSourceFeedbackRequest> = /*@__PURE__*/
  messageDesc(file_security_security, 11);

/**
 * @generated from message lvdr.v2.security.SubmitSourceFeedbackResponse
 */
export type SubmitSourceFeedbackResponse = Message<"lvdr.v2.security.SubmitSourceFeedbackResponse"> & {
  /**
   * @generated from field: string status = 1;
   */
  status: string;
};

/**
 * Describes the message lvdr.v2.security.SubmitSourceFeedbackResponse.
 * Use `create(SubmitSourceFeedbackResponseSchema)` to create a new message.
 */
export const SubmitSourceFeedbackResponseSchema: GenMessage<SubmitSourceFeedbackResponse> = /*@__PURE__*/
  messageDesc(file_security_security, 12);

/**
 * Mark a domain as trustworthy / untrustworthy for the authenticated user.
 * Mirrors HTTP POST /security/domains/:domain/reputation. `scope` defaults
 * to "user" when empty; `reputation` is validated server-side and must be
 * "trustworthy" or "untrustworthy".
 *
 * @generated from message lvdr.v2.security.UpdateDomainReputationRequest
 */
export type UpdateDomainReputationRequest = Message<"lvdr.v2.security.UpdateDomainReputationRequest"> & {
  /**
   * @generated from field: string domain = 1;
   */
  domain: string;

  /**
   * @generated from field: string reputation = 2;
   */
  reputation: string;

  /**
   * @generated from field: string scope = 3;
   */
  scope: string;
};

/**
 * Describes the message lvdr.v2.security.UpdateDomainReputationRequest.
 * Use `create(UpdateDomainReputationRequestSchema)` to create a new message.
 */
export const UpdateDomainReputationRequestSchema: GenMessage<UpdateDomainReputationRequest> = /*@__PURE__*/
  messageDesc(file_security_security, 13);

/**
 * Returned on create. Matches internal/security/feedback.DomainReputation.
 *
 * @generated from message lvdr.v2.security.DomainReputationEntry
 */
export type DomainReputationEntry = Message<"lvdr.v2.security.DomainReputationEntry"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string domain = 2;
   */
  domain: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * @generated from field: string reputation = 4;
   */
  reputation: string;

  /**
   * @generated from field: string scope = 5;
   */
  scope: string;

  /**
   * @generated from field: string approval_status = 6;
   */
  approvalStatus: string;

  /**
   * @generated from field: string approved_by = 7;
   */
  approvedBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 8;
   */
  createdAt?: Timestamp | undefined;

  /**
   * unset = no expiry
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 9;
   */
  expiresAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.security.DomainReputationEntry.
 * Use `create(DomainReputationEntrySchema)` to create a new message.
 */
export const DomainReputationEntrySchema: GenMessage<DomainReputationEntry> = /*@__PURE__*/
  messageDesc(file_security_security, 14);

/**
 * @generated from message lvdr.v2.security.UpdateDomainReputationResponse
 */
export type UpdateDomainReputationResponse = Message<"lvdr.v2.security.UpdateDomainReputationResponse"> & {
  /**
   * @generated from field: lvdr.v2.security.DomainReputationEntry entry = 1;
   */
  entry?: DomainReputationEntry | undefined;
};

/**
 * Describes the message lvdr.v2.security.UpdateDomainReputationResponse.
 * Use `create(UpdateDomainReputationResponseSchema)` to create a new message.
 */
export const UpdateDomainReputationResponseSchema: GenMessage<UpdateDomainReputationResponse> = /*@__PURE__*/
  messageDesc(file_security_security, 15);

/**
 * SourceThresholds: block ≥ flag, both in [0.0, 1.0].
 *
 * @generated from message lvdr.v2.security.SourceThresholds
 */
export type SourceThresholds = Message<"lvdr.v2.security.SourceThresholds"> & {
  /**
   * @generated from field: double block = 1;
   */
  block: number;

  /**
   * @generated from field: double flag = 2;
   */
  flag: number;
};

/**
 * Describes the message lvdr.v2.security.SourceThresholds.
 * Use `create(SourceThresholdsSchema)` to create a new message.
 */
export const SourceThresholdsSchema: GenMessage<SourceThresholds> = /*@__PURE__*/
  messageDesc(file_security_security, 16);

/**
 * @generated from message lvdr.v2.security.ThresholdConfig
 */
export type ThresholdConfig = Message<"lvdr.v2.security.ThresholdConfig"> & {
  /**
   * "strict" | "balanced" | "permissive"
   *
   * @generated from field: string preset = 1;
   */
  preset: string;

  /**
   * @generated from field: map<string, lvdr.v2.security.SourceThresholds> overrides = 2;
   */
  overrides: { [key: string]: SourceThresholds };
};

/**
 * Describes the message lvdr.v2.security.ThresholdConfig.
 * Use `create(ThresholdConfigSchema)` to create a new message.
 */
export const ThresholdConfigSchema: GenMessage<ThresholdConfig> = /*@__PURE__*/
  messageDesc(file_security_security, 17);

/**
 * @generated from message lvdr.v2.security.GetThresholdConfigRequest
 */
export type GetThresholdConfigRequest = Message<"lvdr.v2.security.GetThresholdConfigRequest"> & {
};

/**
 * Describes the message lvdr.v2.security.GetThresholdConfigRequest.
 * Use `create(GetThresholdConfigRequestSchema)` to create a new message.
 */
export const GetThresholdConfigRequestSchema: GenMessage<GetThresholdConfigRequest> = /*@__PURE__*/
  messageDesc(file_security_security, 18);

/**
 * @generated from message lvdr.v2.security.UpdateThresholdConfigRequest
 */
export type UpdateThresholdConfigRequest = Message<"lvdr.v2.security.UpdateThresholdConfigRequest"> & {
  /**
   * @generated from field: lvdr.v2.security.ThresholdConfig config = 1;
   */
  config?: ThresholdConfig | undefined;
};

/**
 * Describes the message lvdr.v2.security.UpdateThresholdConfigRequest.
 * Use `create(UpdateThresholdConfigRequestSchema)` to create a new message.
 */
export const UpdateThresholdConfigRequestSchema: GenMessage<UpdateThresholdConfigRequest> = /*@__PURE__*/
  messageDesc(file_security_security, 19);

/**
 * @generated from message lvdr.v2.security.ThresholdConfigResponse
 */
export type ThresholdConfigResponse = Message<"lvdr.v2.security.ThresholdConfigResponse"> & {
  /**
   * @generated from field: lvdr.v2.security.ThresholdConfig config = 1;
   */
  config?: ThresholdConfig | undefined;
};

/**
 * Describes the message lvdr.v2.security.ThresholdConfigResponse.
 * Use `create(ThresholdConfigResponseSchema)` to create a new message.
 */
export const ThresholdConfigResponseSchema: GenMessage<ThresholdConfigResponse> = /*@__PURE__*/
  messageDesc(file_security_security, 20);

/**
 * ModelTrustEntry: a trimmed researchion of mesh.ModelEntry. The full ModelEntry
 * has many fields (capabilities, rate limits, cost tiers) unused by the trust
 * UI; surface just the fields the UI toggles so callers can't accidentally
 * mutate availability / rate-limit state via a round-trip.
 *
 * @generated from message lvdr.v2.security.ModelTrustEntry
 */
export type ModelTrustEntry = Message<"lvdr.v2.security.ModelTrustEntry"> & {
  /**
   * @generated from field: string model_id = 1;
   */
  modelId: string;

  /**
   * @generated from field: string provider = 2;
   */
  provider: string;

  /**
   * "trusted" | "standard" | "untrusted"
   *
   * @generated from field: string trust_tier = 3;
   */
  trustTier: string;

  /**
   * @generated from field: bool enabled = 4;
   */
  enabled: boolean;
};

/**
 * Describes the message lvdr.v2.security.ModelTrustEntry.
 * Use `create(ModelTrustEntrySchema)` to create a new message.
 */
export const ModelTrustEntrySchema: GenMessage<ModelTrustEntry> = /*@__PURE__*/
  messageDesc(file_security_security, 21);

/**
 * @generated from message lvdr.v2.security.GetModelTrustConfigRequest
 */
export type GetModelTrustConfigRequest = Message<"lvdr.v2.security.GetModelTrustConfigRequest"> & {
};

/**
 * Describes the message lvdr.v2.security.GetModelTrustConfigRequest.
 * Use `create(GetModelTrustConfigRequestSchema)` to create a new message.
 */
export const GetModelTrustConfigRequestSchema: GenMessage<GetModelTrustConfigRequest> = /*@__PURE__*/
  messageDesc(file_security_security, 22);

/**
 * @generated from message lvdr.v2.security.UpdateModelTrustConfigRequest
 */
export type UpdateModelTrustConfigRequest = Message<"lvdr.v2.security.UpdateModelTrustConfigRequest"> & {
  /**
   * @generated from field: repeated lvdr.v2.security.ModelTrustEntry models = 1;
   */
  models: ModelTrustEntry[];
};

/**
 * Describes the message lvdr.v2.security.UpdateModelTrustConfigRequest.
 * Use `create(UpdateModelTrustConfigRequestSchema)` to create a new message.
 */
export const UpdateModelTrustConfigRequestSchema: GenMessage<UpdateModelTrustConfigRequest> = /*@__PURE__*/
  messageDesc(file_security_security, 23);

/**
 * @generated from message lvdr.v2.security.ModelTrustConfigResponse
 */
export type ModelTrustConfigResponse = Message<"lvdr.v2.security.ModelTrustConfigResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.security.ModelTrustEntry models = 1;
   */
  models: ModelTrustEntry[];
};

/**
 * Describes the message lvdr.v2.security.ModelTrustConfigResponse.
 * Use `create(ModelTrustConfigResponseSchema)` to create a new message.
 */
export const ModelTrustConfigResponseSchema: GenMessage<ModelTrustConfigResponse> = /*@__PURE__*/
  messageDesc(file_security_security, 24);

/**
 * Mirrors internal/security/audit.AuditEvent. Timestamps are protobuf
 * Timestamp, not ISO strings — the HTTP transport used RFC3339 because JSON
 * lacks a typed timestamp.
 *
 * @generated from message lvdr.v2.security.AuditEvent
 */
export type AuditEvent = Message<"lvdr.v2.security.AuditEvent"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 2;
   */
  timestamp?: Timestamp | undefined;

  /**
   * @generated from field: string event_type = 3;
   */
  eventType: string;

  /**
   * @generated from field: string actor = 4;
   */
  actor: string;

  /**
   * @generated from field: string research_id = 5;
   */
  researchId: string;

  /**
   * @generated from field: string user_id = 6;
   */
  userId: string;

  /**
   * @generated from field: string content_hash = 7;
   */
  contentHash: string;

  /**
   * @generated from field: string decision = 8;
   */
  decision: string;

  /**
   * @generated from field: string reason = 9;
   */
  reason: string;

  /**
   * @generated from field: repeated string tags = 10;
   */
  tags: string[];

  /**
   * @generated from field: double risk_score = 11;
   */
  riskScore: number;

  /**
   * @generated from field: string confidence = 12;
   */
  confidence: string;

  /**
   * @generated from field: string trace_id = 13;
   */
  traceId: string;

  /**
   * @generated from field: string task_id = 14;
   */
  taskId: string;

  /**
   * @generated from field: string error_code = 15;
   */
  errorCode: string;

  /**
   * @generated from field: string severity = 16;
   */
  severity: string;

  /**
   * @generated from field: string source = 17;
   */
  source: string;

  /**
   * Extra is map<string, Any> on the wire — JSON-encoded per value to preserve
   * the open schema of the HTTP `extra` field. Frontend parses on demand.
   *
   * @generated from field: map<string, string> extra = 18;
   */
  extra: { [key: string]: string };

  /**
   * @generated from field: bool is_shadow = 19;
   */
  isShadow: boolean;

  /**
   * @generated from field: string original_decision = 20;
   */
  originalDecision: string;
};

/**
 * Describes the message lvdr.v2.security.AuditEvent.
 * Use `create(AuditEventSchema)` to create a new message.
 */
export const AuditEventSchema: GenMessage<AuditEvent> = /*@__PURE__*/
  messageDesc(file_security_security, 25);

/**
 * ListAuditEventsRequest mirrors the HTTP query params of
 * GET /security/audit/events. `types` and `severities` were comma-separated
 * query strings over HTTP; here they are proper repeated fields.
 *
 * @generated from message lvdr.v2.security.ListAuditEventsRequest
 */
export type ListAuditEventsRequest = Message<"lvdr.v2.security.ListAuditEventsRequest"> & {
  /**
   * @generated from field: string research_id = 1;
   */
  researchId: string;

  /**
   * @generated from field: repeated string types = 2;
   */
  types: string[];

  /**
   * @generated from field: repeated string severities = 3;
   */
  severities: string[];

  /**
   * @generated from field: google.protobuf.Timestamp date_from = 4;
   */
  dateFrom?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp date_to = 5;
   */
  dateTo?: Timestamp | undefined;

  /**
   * @generated from field: string search = 6;
   */
  search: string;

  /**
   * default 50, server clamps
   *
   * @generated from field: int32 limit = 7;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 8;
   */
  offset: number;
};

/**
 * Describes the message lvdr.v2.security.ListAuditEventsRequest.
 * Use `create(ListAuditEventsRequestSchema)` to create a new message.
 */
export const ListAuditEventsRequestSchema: GenMessage<ListAuditEventsRequest> = /*@__PURE__*/
  messageDesc(file_security_security, 26);

/**
 * @generated from message lvdr.v2.security.ListAuditEventsResponse
 */
export type ListAuditEventsResponse = Message<"lvdr.v2.security.ListAuditEventsResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.security.AuditEvent events = 1;
   */
  events: AuditEvent[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;

  /**
   * @generated from field: int32 limit = 3;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 4;
   */
  offset: number;
};

/**
 * Describes the message lvdr.v2.security.ListAuditEventsResponse.
 * Use `create(ListAuditEventsResponseSchema)` to create a new message.
 */
export const ListAuditEventsResponseSchema: GenMessage<ListAuditEventsResponse> = /*@__PURE__*/
  messageDesc(file_security_security, 27);

/**
 * Detail lookup — mirrors HTTP GET /security/audit/events/:id.
 *
 * @generated from message lvdr.v2.security.GetAuditEventRequest
 */
export type GetAuditEventRequest = Message<"lvdr.v2.security.GetAuditEventRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;
};

/**
 * Describes the message lvdr.v2.security.GetAuditEventRequest.
 * Use `create(GetAuditEventRequestSchema)` to create a new message.
 */
export const GetAuditEventRequestSchema: GenMessage<GetAuditEventRequest> = /*@__PURE__*/
  messageDesc(file_security_security, 28);

/**
 * @generated from message lvdr.v2.security.GetAuditEventResponse
 */
export type GetAuditEventResponse = Message<"lvdr.v2.security.GetAuditEventResponse"> & {
  /**
   * @generated from field: lvdr.v2.security.AuditEvent event = 1;
   */
  event?: AuditEvent | undefined;
};

/**
 * Describes the message lvdr.v2.security.GetAuditEventResponse.
 * Use `create(GetAuditEventResponseSchema)` to create a new message.
 */
export const GetAuditEventResponseSchema: GenMessage<GetAuditEventResponse> = /*@__PURE__*/
  messageDesc(file_security_security, 29);

/**
 * @generated from message lvdr.v2.security.SubmitAuditFeedbackRequest
 */
export type SubmitAuditFeedbackRequest = Message<"lvdr.v2.security.SubmitAuditFeedbackRequest"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * "false_positive" | "false_negative" | "correct"
   *
   * @generated from field: string verdict = 2;
   */
  verdict: string;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * @generated from field: string domain = 4;
   */
  domain: string;

  /**
   * @generated from field: string pattern_id = 5;
   */
  patternId: string;
};

/**
 * Describes the message lvdr.v2.security.SubmitAuditFeedbackRequest.
 * Use `create(SubmitAuditFeedbackRequestSchema)` to create a new message.
 */
export const SubmitAuditFeedbackRequestSchema: GenMessage<SubmitAuditFeedbackRequest> = /*@__PURE__*/
  messageDesc(file_security_security, 30);

/**
 * AuditFeedback mirrors internal/security/feedback.Feedback.
 *
 * @generated from message lvdr.v2.security.AuditFeedback
 */
export type AuditFeedback = Message<"lvdr.v2.security.AuditFeedback"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string audit_event_id = 2;
   */
  auditEventId: string;

  /**
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * @generated from field: string verdict = 4;
   */
  verdict: string;

  /**
   * @generated from field: string reason = 5;
   */
  reason: string;

  /**
   * @generated from field: string domain = 6;
   */
  domain: string;

  /**
   * @generated from field: string pattern_id = 7;
   */
  patternId: string;

  /**
   * @generated from field: string status = 8;
   */
  status: string;

  /**
   * @generated from field: string reviewed_by = 9;
   */
  reviewedBy: string;

  /**
   * @generated from field: google.protobuf.Timestamp reviewed_at = 10;
   */
  reviewedAt?: Timestamp | undefined;

  /**
   * @generated from field: string second_reviewer = 11;
   */
  secondReviewer: string;

  /**
   * @generated from field: google.protobuf.Timestamp second_reviewed_at = 12;
   */
  secondReviewedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.security.AuditFeedback.
 * Use `create(AuditFeedbackSchema)` to create a new message.
 */
export const AuditFeedbackSchema: GenMessage<AuditFeedback> = /*@__PURE__*/
  messageDesc(file_security_security, 31);

/**
 * @generated from message lvdr.v2.security.SubmitAuditFeedbackResponse
 */
export type SubmitAuditFeedbackResponse = Message<"lvdr.v2.security.SubmitAuditFeedbackResponse"> & {
  /**
   * @generated from field: lvdr.v2.security.AuditFeedback feedback = 1;
   */
  feedback?: AuditFeedback | undefined;
};

/**
 * Describes the message lvdr.v2.security.SubmitAuditFeedbackResponse.
 * Use `create(SubmitAuditFeedbackResponseSchema)` to create a new message.
 */
export const SubmitAuditFeedbackResponseSchema: GenMessage<SubmitAuditFeedbackResponse> = /*@__PURE__*/
  messageDesc(file_security_security, 32);

/**
 * DraftPattern mirrors the HTTP createRequest struct, used only as the
 * contents of `draft_patterns` / `draft_exclusions` during simulation.
 * The real persisted PatternRecord lives in the custom-patterns proto
 * surface (not migrated in Wave 4) — this is a simulation-only DTO.
 *
 * @generated from message lvdr.v2.security.DraftPattern
 */
export type DraftPattern = Message<"lvdr.v2.security.DraftPattern"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * "regex" | "keywords"
   *
   * @generated from field: string pattern_type = 2;
   */
  patternType: string;

  /**
   * @generated from field: string pattern = 3;
   */
  pattern: string;

  /**
   * @generated from field: bool case_sensitive = 4;
   */
  caseSensitive: boolean;

  /**
   * @generated from field: string sensitivity = 5;
   */
  sensitivity: string;

  /**
   * @generated from field: string clearance = 6;
   */
  clearance: string;

  /**
   * @generated from field: string description = 7;
   */
  description: string;

  /**
   * @generated from field: bool is_exclusion = 8;
   */
  isExclusion: boolean;
};

/**
 * Describes the message lvdr.v2.security.DraftPattern.
 * Use `create(DraftPatternSchema)` to create a new message.
 */
export const DraftPatternSchema: GenMessage<DraftPattern> = /*@__PURE__*/
  messageDesc(file_security_security, 33);

/**
 * @generated from message lvdr.v2.security.SimulateSecurityDecisionRequest
 */
export type SimulateSecurityDecisionRequest = Message<"lvdr.v2.security.SimulateSecurityDecisionRequest"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: repeated lvdr.v2.security.DraftPattern draft_patterns = 2;
   */
  draftPatterns: DraftPattern[];

  /**
   * @generated from field: repeated lvdr.v2.security.DraftPattern draft_exclusions = 3;
   */
  draftExclusions: DraftPattern[];
};

/**
 * Describes the message lvdr.v2.security.SimulateSecurityDecisionRequest.
 * Use `create(SimulateSecurityDecisionRequestSchema)` to create a new message.
 */
export const SimulateSecurityDecisionRequestSchema: GenMessage<SimulateSecurityDecisionRequest> = /*@__PURE__*/
  messageDesc(file_security_security, 34);

/**
 * SimulateTag mirrors the `simulateTag` HTTP shape. `span` is two ints —
 * keeping it as two scalar fields avoids proto-list semantics on the wire.
 *
 * @generated from message lvdr.v2.security.SimulateTag
 */
export type SimulateTag = Message<"lvdr.v2.security.SimulateTag"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: int32 span_start = 2;
   */
  spanStart: number;

  /**
   * @generated from field: int32 span_end = 3;
   */
  spanEnd: number;

  /**
   * @generated from field: string pattern = 4;
   */
  pattern: string;

  /**
   * @generated from field: double confidence = 5;
   */
  confidence: number;

  /**
   * @generated from field: string action = 6;
   */
  action: string;
};

/**
 * Describes the message lvdr.v2.security.SimulateTag.
 * Use `create(SimulateTagSchema)` to create a new message.
 */
export const SimulateTagSchema: GenMessage<SimulateTag> = /*@__PURE__*/
  messageDesc(file_security_security, 35);

/**
 * @generated from message lvdr.v2.security.SimulateSecurityDecisionResponse
 */
export type SimulateSecurityDecisionResponse = Message<"lvdr.v2.security.SimulateSecurityDecisionResponse"> & {
  /**
   * @generated from field: repeated lvdr.v2.security.SimulateTag tags = 1;
   */
  tags: SimulateTag[];

  /**
   * @generated from field: double risk_score = 2;
   */
  riskScore: number;

  /**
   * @generated from field: string redacted_text = 3;
   */
  redactedText: string;

  /**
   * @generated from field: map<string, int32> pattern_hits = 4;
   */
  patternHits: { [key: string]: number };
};

/**
 * Describes the message lvdr.v2.security.SimulateSecurityDecisionResponse.
 * Use `create(SimulateSecurityDecisionResponseSchema)` to create a new message.
 */
export const SimulateSecurityDecisionResponseSchema: GenMessage<SimulateSecurityDecisionResponse> = /*@__PURE__*/
  messageDesc(file_security_security, 36);

